<template>
    <div class="container-xxl padding-container-matrix">
        <div class="row justify-content-center">
            <div class="col-matrix">
                <div class="row justify-content-between justify-content-xxl-between">
                    <div class="col-12 col-lg-6 col-xl-5 d-flex align-items-lg-center">
                        <h3 class="font-size-h1 text-center text-lg-start w-100">{{sectionBlock.sectionTitle}}</h3>
                    </div>

                    <div class="col-12 col-lg-6 col-xl-7 col-xxl-6 overflow-hidden">

                        <div class="swiper-stats">
                            <div class="swiper-wrapper">
                                <div
                                    v-for="(slide, index) in sectionBlock.slide"
                                    :key="'swiper-slide-' + index"
                                    class="swiper-slide"
                                >

                                    <div class="row justify-content-center justify-content-lg-end w-100">
                                        <div class="col-12">
                                            <h3
                                                class="font-size-100 text-red text-center text-lg-end"
                                            >
                                                {{slide.number}}
                                            </h3>
                                        </div>
                                        <div class="col-12 col-sm-10 col-lg-10">
                                            <h5 class="text-center text-lg-end pe-lg-5">{{slide.text}}</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

// import Swiper bundle with all modules installed
import Swiper from 'swiper/swiper-bundle.js'

// import styles bundle
import 'swiper/swiper-bundle.min.css'

export default {
    name: 'InisStats',
    components: {},
    props: {
        sectionBlock: {
            type: Object,
            required: true,
        },
    },
    watch: {
        pageIsLoaded: {
            async handler(pageIsLoaded) {
                if (pageIsLoaded) {
                    // Page loaded with Data

                    setTimeout(function () {

                        new Swiper('.swiper-stats', {
                            // Optional parameters
                            loop: true,
                            slidesPerView: 1,
                            autoplay: {
                              delay: 2500,
                              disableOnInteraction: false,
                            },
                        })
                    }, 2000)
                }
            },
            immediate: true,
        },
    },
    computed: {
        pageIsLoaded() {
            return this.contentIsLoaded && this.globalsIsLoaded
        },
        ...mapState(['contentIsLoaded', 'globalsIsLoaded']),
        ...mapGetters(['content']),
    },
}
</script>
